// extracted by css-extract-rspack-plugin
export default {"form":"fzUbGV43ZM3pA7qf","items":"BY5QuS5pNM9bhRc8"};